'use client';

import { Switch } from '@mantine/core';
import { IconArrowDown } from '@/icons/IconArrowDown';
import { IconLocation } from '@/icons/IconLocation';

interface Props {
  text: string;
  onClick: () => void;
  isSelected: boolean;
  isHeader?: boolean;
  title?: string;
  onSwitchChange?: () => void;
  hasValue?: boolean;
}

const BUTTON_RESET = 'rounded-none bg-transparent p-0 h-auto';

export function LocationSelector({ text, onClick, isSelected, isHeader = false, title, onSwitchChange, hasValue }: Readonly<Props>) {
  function handleClick(e: any) {
    e.preventDefault();
    e.stopPropagation();

    onClick();
  }

  if (isHeader) {
    return (
      <button onClick={handleClick} className={`flex min-w-0 flex-1 cursor-pointer items-center justify-center space-x-2 px-2 ${BUTTON_RESET}`}>
        <p className={`truncate text-base font-medium ${isSelected ? '' : 'text-[#525866]'}`}>{text}</p>
        <IconArrowDown className="mt-[1px] h-4 w-4 flex-shrink-0" />
      </button>
    );
  }

  return (
    <div className="mb-5 space-y-[8px]">
      <div className="flex items-center justify-between">
        {title && <p className="text-center text-xl font-semibold">{title}</p>}

        <Switch
          className={`${!hasValue && '!cursor-not-allowed'}`}
          {...(hasValue && { styles: { track: { cursor: 'pointer' } } })}
          checked={isSelected}
          onChange={onSwitchChange}
          size="md"
          disabled={!hasValue}
        />
      </div>
      <button
        onClick={handleClick}
        className={`m-0 flex h-auto w-full cursor-pointer items-center rounded-[4px] border border-[#E5E7EB] px-[8px] py-[9px]`}
      >
        <IconLocation className="mr-2 h-6 w-6" />
        <p className={`${hasValue ? '' : 'text-[#525866]'} text-base`}>{text}</p>
      </button>
    </div>
  );
}
